export const DEFAULT_ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;

export const DEFAULT_TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;
